import * as React from 'react'

import SafeInnerHtml from '../../../components/safeInnerHtml'

import * as styles from './tutorialPost.module.css'

interface IProps {
  imgSrc: string
  title: string
  link: string
  description: string
}

const TutorialPost = ({ imgSrc, title, link, description }: IProps) => {
  return (
    <article className={styles.root}>
      <header>
        <a href={link}>
          <img src={imgSrc} className={styles.img} />
        </a>
        <a href={link} className={styles.title}>
          {title}
        </a>
      </header>
      <section className={styles.description}>
        <SafeInnerHtml html={description} />
      </section>
    </article>
  )
}

export default TutorialPost



// WEBPACK FOOTER //
// ./client/pages/home/tutorialPost/tutorialPost.tsx